import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiClientService } from '../../../app/shared/services/api-client.service';
import { AB_API_SENTOO_PAYMENT_DETAILS } from './../../../app/shared/constants';


export interface Transfer {
  transferId: number;
  beneficiaryName: string;
  beneficiaryHouseNumber: string | null;
  beneficiaryStreet: string | null;
  beneficiaryCity: string | null;
  beneficiaryPostalCode: string | null;
  beneficiaryInstitutionName: string;
  beneficiaryInstitutionCode: string;
  beneficiaryInstitutionCodeValue: string;
  valueDate: string;
  description: string;
  destinationCountryISOCode?: string;
  sourceAccount: string | null;
  beneficiaryAccount: string;
  currency: string;
  amount: number;
  referenceCategoryNumber: string | null;
  sentooTransactionId: string;
  sentooProcessorId: string;
  transactionType: string;
  userAccountPermissions: UserAccountPermission[];
}

interface UserAccountPermission {
  accountNumber: string;
  accountName: string;
  accessEnabled: boolean;
  specificEnabled: boolean;
  access: Access[];
}

interface Access {
  id: string;
  enable: boolean;
  upload: boolean;
  create: boolean;
  modify: boolean;
  approve: boolean;
  inquire: boolean;
  delete: boolean;
  createApproval: boolean;
  amountLimit: number;
  totalApproval: number;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentDetailsService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_SENTOO_PAYMENT_DETAILS);
  }

  getPaymentDetails(encryptedData: string): Observable<Transfer> {
    const params = new HttpParams().set('encryptedData', '?' + encryptedData);
    return this.get(params);
  }
}
